export default __webpack_public_path__ + "static/media/rules-smoking.512bca95.svg";